module.exports = __webpack_public_path__ + "img/poza-popup.c3003a51.jpeg";